(function () {
  'use strict';
  var controls = new Map();
  var active = null;
  var serial = 0;
  var scanTimer = null;
  var observer = null;
  var escapePending = false;

  function label(select) {
    return select.getAttribute('aria-label') || Array.from(select.labels || []).map(function (node) { return node.textContent.trim(); }).join(' ') || select.title || select.name || 'Choose an option';
  }
  function optionLabel(option) { return option ? option.label.trim() : ''; }
  function visible(node) {
    for (; node && node !== document.body; node = node.parentElement) {
      var style = getComputedStyle(node);
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    }
    return true;
  }
  function enabled(option) {
    return !!option && !option.disabled && !(option.parentElement && option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled);
  }
  function close(restoreFocus) {
    if (!active) return;
    var state = active;
    active = null;
    state.button.setAttribute('aria-expanded', 'false');
    state.panel.remove();
    state.panel = null;
    if (restoreFocus && state.button.isConnected) state.button.focus();
  }
  function sync(state) {
    var select = state.select;
    var selected = select.options[select.selectedIndex];
    var style = getComputedStyle(select);
    var hidden = select.hidden || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse';
    if (state.host.hidden !== hidden) state.host.hidden = hidden;
    if (hidden && active === state) close(false);
    state.value.textContent = selected ? optionLabel(selected) : '';
    state.button.disabled = select.disabled;
    if (!state.error && select.getAttribute('aria-describedby')) state.button.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
    state.button.setAttribute('aria-label', label(select) + (selected ? ': ' + optionLabel(selected) : ''));
    if (select.validity.valid && state.error) {
      state.error.remove(); state.error = null;
      state.button.removeAttribute('aria-invalid');
      if (select.getAttribute('aria-describedby')) state.button.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
      else state.button.removeAttribute('aria-describedby');
    }
    if (active === state && select.disabled) close(false);
  }
  function highlight(state, index) {
    var options = Array.from(state.select.options);
    if (!options[index] || !enabled(options[index])) return;
    state.index = index;
    state.rows.forEach(function (row, i) { row.classList.toggle('is-active', i === index); });
    state.panel.setAttribute('aria-activedescendant', state.rows[index].id);
    state.rows[index].scrollIntoView({ block: 'nearest' });
  }
  function move(state, direction, edge) {
    var available = Array.from(state.select.options).map(function (option, index) { return enabled(option) ? index : -1; }).filter(function (index) { return index >= 0; });
    if (!available.length) return;
    var position = available.indexOf(state.index);
    var next = edge === 'start' ? available[0] : edge === 'end' ? available[available.length - 1] : available[(position + direction + available.length) % available.length];
    highlight(state, next);
  }
  function choose(state, index) {
    var option = state.select.options[index];
    if (!option || !state.options || option !== state.options[index] || option.value !== state.optionValues[index]) { close(true); return; }
    if (state.select.disabled || !enabled(state.select.options[index])) return;
    var changed = state.select.selectedIndex !== index;
    state.select.selectedIndex = index;
    sync(state);
    close(true);
    if (changed) {
      state.select.dispatchEvent(new Event('input', { bubbles: true }));
      state.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function open(state, last) {
    if (state.select.disabled || !state.button.isConnected) return;
    if (active === state) { close(true); return; }
    close(false);
    sync(state);
    var panel = document.createElement('div');
    panel.id = state.button.getAttribute('aria-controls');
    panel.className = 'BrandSelectPanel';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', label(state.select));
    panel.tabIndex = -1;
    state.panel = panel;
    state.rows = [];
    state.options = Array.from(state.select.options);
    state.optionValues = state.options.map(function (option) { return option.value; });
    state.optionLabels = state.options.map(optionLabel);
    state.optionEnabled = state.options.map(enabled);
    state.options.forEach(function (option, index) {
      var row = document.createElement('div');
      row.id = panel.id + '-option-' + index;
      row.className = 'BrandSelectPanel__Option';
      row.setAttribute('role', 'option');
      row.setAttribute('aria-selected', String(index === state.select.selectedIndex));
      row.setAttribute('aria-disabled', String(!enabled(option)));
      row.textContent = optionLabel(option);
      if (option.parentElement && option.parentElement.tagName === 'OPTGROUP') row.setAttribute('aria-label', option.parentElement.label + ': ' + row.textContent);
      row.addEventListener('click', function () { choose(state, index); });
      state.rows.push(row);
      panel.appendChild(row);
    });
    if (!state.rows.length) { state.panel = null; return; }
    // Keep focus inside the owning drawer/dialog and account for its transformed fixed origin.
    var portal = state.select.closest('.Drawer, .Modal, [role="dialog"], [aria-modal="true"]') || document.body;
    portal.appendChild(panel);
    var rect = state.button.getBoundingClientRect();
    var bounds = portal === document.body ? { left: 0, right: window.innerWidth, top: 0, bottom: window.innerHeight } : portal.getBoundingClientRect();
    var leftEdge = Math.max(0, bounds.left);
    var rightEdge = Math.min(window.innerWidth, bounds.right);
    var topEdge = Math.max(0, bounds.top);
    var bottomEdge = Math.min(window.innerHeight, bounds.bottom);
    var width = Math.min(Math.max(rect.width, 180), Math.max(44, rightEdge - leftEdge - 16));
    var below = bottomEdge - rect.bottom - 16;
    var above = rect.top - topEdge - 16;
    var useAbove = below < 180 && above > below;
    panel.style.animation = 'none';
    panel.style.width = width + 'px';
    panel.style.left = '0px';
    panel.style.top = '0px';
    panel.style.maxHeight = Math.max(44, Math.min(280, useAbove ? above : below)) + 'px';
    var origin = panel.getBoundingClientRect();
    var left = Math.max(leftEdge + 8, Math.min(rect.left, rightEdge - width - 8));
    var top = useAbove ? Math.max(topEdge + 8, rect.top - panel.offsetHeight - 4) : Math.min(rect.bottom + 4, bottomEdge - panel.offsetHeight - 8);
    panel.style.left = (left - origin.left) + 'px';
    panel.style.top = (Math.max(topEdge + 8, top) - origin.top) + 'px';
    panel.style.animation = '';
    active = state;
    state.button.setAttribute('aria-expanded', 'true');
    state.index = state.select.selectedIndex;
    panel.focus();
    if (last) move(state, 0, 'end');
    else if (state.index >= 0 && enabled(state.select.options[state.index])) highlight(state, state.index);
    else move(state, 0, 'start');
    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); close(true); }
      else if (event.key === 'Tab') close(true);
      else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); move(state, event.key === 'ArrowDown' ? 1 : -1); }
      else if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); move(state, 0, event.key === 'Home' ? 'start' : 'end'); }
      else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(state, state.index); }
      else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        var prefix = event.key.toLocaleLowerCase();
        var options = Array.from(state.select.options);
        for (var step = 1; step <= options.length; step += 1) {
          var index = (state.index + step + options.length) % options.length;
          if (enabled(options[index]) && optionLabel(options[index]).toLocaleLowerCase().indexOf(prefix) === 0) { highlight(state, index); break; }
        }
      }
    });
  }
  function enhance(select) {
    if (controls.has(select) || select.multiple || select.size > 1 || select.hasAttribute('data-native-select')) return;
    if (!visible(select)) return;
    var host = document.createElement('span');
    host.className = 'BrandSelect';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'BrandSelect__Trigger';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', 'BrandSelectPanel-' + (++serial));
    var value = document.createElement('span');
    button.appendChild(value);
    var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('viewBox', '0 0 24 24');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '<path d="M5 9l7 7 7-7" fill="none" stroke="currentColor" stroke-width="1.4" />';
    button.appendChild(arrow);
    var state = { select: select, button: button, value: value, host: host, panel: null };
    select.parentNode.insertBefore(host, select);
    host.appendChild(select);
    host.appendChild(button);
    select.classList.add('BrandSelect__Native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    controls.set(select, state);
    sync(state);
    select.addEventListener('change', function () { if (active === state) close(true); sync(state); });
    select.addEventListener('invalid', function (event) {
      event.preventDefault();
      if (!state.error) {
        state.error = document.createElement('span');
        state.error.className = 'BrandSelect__Error';
        state.error.id = button.getAttribute('aria-controls') + '-error';
        state.error.setAttribute('role', 'alert');
        host.appendChild(state.error);
      }
      state.error.textContent = select.validationMessage;
      button.setAttribute('aria-invalid', 'true');
      button.setAttribute('aria-describedby', [select.getAttribute('aria-describedby'), state.error.id].filter(Boolean).join(' '));
      button.focus();
    });
    button.addEventListener('click', function () { open(state); });
    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(state, event.key === 'ArrowUp'); }
    });
  }
  function scan() {
    scanTimer = null;
    if (active) {
      var options = Array.from(active.select.options);
      var stillVisible = active.select.isConnected && visible(active.host);
      var changed = options.length !== active.options.length || options.some(function (option, index) {
        return option !== active.options[index] || option.value !== active.optionValues[index] || optionLabel(option) !== active.optionLabels[index] || enabled(option) !== active.optionEnabled[index];
      });
      if (!stillVisible || active.select.disabled || changed) close(stillVisible);
    }
    controls.forEach(function (state, select) {
      if (!select.isConnected) { if (active === state) close(false); controls.delete(select); }
      else sync(state);
    });
    document.querySelectorAll('select').forEach(enhance);
  }
  function scheduleScan() {
    if (scanTimer === null) scanTimer = window.setTimeout(scan, 0);
  }
  function start() {
    scan();
    if (!observer && document.body) {
      observer = new MutationObserver(function (records) {
        if (records.some(function (record) {
          var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (!target) return false;
          if (target.closest('select')) return true;
          if (record.type === 'attributes') return !!target.querySelector('select');
          return record.type === 'childList' && Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) { return node.nodeType === 1 && (node.tagName === 'SELECT' || node.querySelector('select')); });
        })) scheduleScan();
      });
      observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'selected', 'label', 'value', 'class', 'style', 'hidden', 'aria-hidden'] });
    }
  }
  // Capture before drawer/modal Escape handlers, then consume only the matching keyup.
  window.addEventListener('keydown', function (event) {
    if (active && event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); escapePending = true; close(true); }
  }, true);
  window.addEventListener('keyup', function (event) {
    if (escapePending && event.key === 'Escape') { event.stopPropagation(); escapePending = false; }
  }, true);
  document.addEventListener('pointerdown', function (event) {
    if (active && !active.host.contains(event.target) && !active.panel.contains(event.target)) close(false);
  }, true);
  document.addEventListener('reset', scheduleScan);
  window.addEventListener('scroll', function (event) {
    if (!active) return;
    var target = event.target;
    if (target.nodeType && active.panel.contains(target)) return;
    // Only scrolling the viewport or an owning container moves this trigger.
    // Independent autoplay rails must not dismiss an unrelated select menu.
    if (target === window || target === document || (target.nodeType && target.contains(active.button))) close(false);
  }, true);
  window.addEventListener('resize', function () { close(false); });
  window.addEventListener('pagehide', function () {
    close(false);
    escapePending = false;
    if (observer) observer.disconnect();
    observer = null;
    if (scanTimer !== null) window.clearTimeout(scanTimer);
    scanTimer = null;
  });
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
